module.exports = __webpack_public_path__ + "static/media/multiple-dropoffs.4c6329cb.svg";